<template>
    <vue-model
            :modal_title="word.join_matchmarry"
            v-if="showModal"
            @close="showModal = false"
    >
        <template v-slot:body>
            <div style="height: 100%">
                <div class="register-step-two" style="height: 100%">
                    <form class="regForm">
                        <loading
                                color="green"
                                :active="loading"
                                spinner="bar-fade-scale"
                        />
                        <div v-if="step == 1" class="tab">
                            <div class="title-step-register2">
                                <h4>{{ word.register }}</h4>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="email">{{ word.email }}</label>
                                    <input
                                            type="email"
                                            class="form-control inputimport"
                                            id="email"
                                            v-model="email"
                                            :placeholder="text.enter_your_email"
                                    />
                                    <small v-if="validationErrors.email !== null" class="text-danger">
                                        {{validationErrors.email}}
                                    </small>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="password">{{ word.password }}</label>
                                    <input
                                            type="password"
                                            class="form-control inputimport"
                                            id="password"
                                            v-model="password"
                                            :placeholder="text.enter_your_password"
                                    />
                                    <small v-if="validationErrors.password !== null" class="text-danger">
                                        {{validationErrors.password}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <!-- One "tab" for each step in the form: -->
                        <div v-if="step == 2" class="tab">
                            <div class="title-step-register2">
                                <h4>{{ word.about_you }}</h4>
                            </div>

                            <div class="row">
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="row">
                                            <label for="name" class="col-form-label col-sm-2">{{ word.name
                                                }}</label>
                                            <div class="col-sm-10">
                                                <input
                                                        type="text"
                                                        class="form-control inputimport"
                                                        id="name"
                                                        v-model="name"
                                                        :placeholder="text.enter_your_name"
                                                />
                                                <small v-if="validationErrors.name !== null" class="text-danger">
                                                    {{validationErrors.name}}
                                                </small>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <label for="inputEmail4" class="col-form-label col-sm-2">{{ word.i_am_a
                                                }}</label>
                                            <div class="col-sm-4 gender">
                                                <label>
                                                    <input
                                                            type="radio"
                                                            value="man"
                                                            v-model="iAm"
                                                    />
                                                    <div class="male box">
                                                        <span class="sex-type">
                                                            <i class="fas fa-male"></i>
                                                            {{ word.man }}
                                                        </span>
                                                    </div>
                                                </label>
                                                <label>
                                                    <input
                                                            type="radio"
                                                            value="woman"
                                                            v-model="iAm"
                                                    />
                                                    <div class="female box">
                                                        <span class="sex-type">
                                                            <i class="fas fa-female"></i>
                                                            {{ word.woman }}
                                                        </span>
                                                    </div>
                                                </label>

                                            </div>
                                            <label for="inputPassword4" class="col-form-label col-sm-2">{{
                                                word.looking_for }}</label>
                                            <div class="col-sm-4 gender">
                                                <label>
                                                    <input
                                                            type="radio"
                                                            value="man"
                                                            v-model="lookingFor"
                                                    />
                                                    <div class="male box">
                                                        <span class="sex-type">
                                                            <i class="fas fa-male"></i>
                                                            {{ word.man }}
                                                        </span>
                                                    </div>
                                                </label>
                                                <label>
                                                    <input
                                                            type="radio"
                                                            value="woman"
                                                            v-model="lookingFor"
                                                    />
                                                    <div class="female box">
                                                        <span class="sex-type">
                                                            <i class="fas fa-female"></i>
                                                            {{ word.woman }}
                                                        </span>
                                                    </div>
                                                </label>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <label class="col-form-label col-sm-2">{{ word.between_ages }}:</label>
                                            <div class="col-sm-4">
                                                <div class="age-slider-select">
                                                    <div class="select">
                                                        <select v-model="startAge" class="form-control">
                                                            <option v-for="(number, i) in ages" :key="i">{{ number
                                                                }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <label class="col-form-label col-sm-2">{{ word.and }}</label>
                                            <div class="col-sm-4">
                                                <div class="age-slider-select">
                                                    <div class="select">
                                                        <select v-model="endAge" class="form-control">
                                                            <option v-for="(number, i) in ages" :key="i">{{ number
                                                                }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <label class="col-form-label col-sm-2">{{ word.favorite_countries
                                                }}:</label>
                                            <div class="col-sm-10">
                                                <div class="age-slider-select">
                                                    <multiselect
                                                            v-model="countries"
                                                            label="name"
                                                            track-by="id"
                                                            :placeholder="text.select_favorite_countries"
                                                            :options="favoriteCountries"
                                                            :multiple="true"
                                                            select-label=""
                                                            deselect-label=""
                                                            selected-label=""
                                                            open-direction="bottom"
                                                            :internal-search="true"
                                                            :max-height="300"
                                                            :show-no-results="true"
                                                            :hide-selected="false"
                                                            :close-on-select="false"
                                                            :limit="0"
                                                            :limit-text="favoriteCountryLimitText"
                                                            @select=onFavoriteCountrySelect($event)
                                                            @remove=onFavoriteCountryRemove($event)
                                                    >
                                                        <span class="favorite-country-checkbox-label" slot="option"
                                                              slot-scope="scope" @click.self="select(scope.option)">
                                                            <input class="favorite-country-checkbox" type="checkbox"
                                                                   v-model="scope.option.checked" @focus.prevent/>
                                                            {{ scope.option.name }}
                                                        </span>
                                                        <span slot="noResult">{{text.no_elements_found}}</span>
                                                        <span slot="noOptions">{{text.enter_something_for_suggestion}}</span>
                                                    </multiselect>
                                                    <small v-if="validationErrors.countries !== null"
                                                           class="text-danger">{{validationErrors.countries}}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <label class="col-form-label col-sm-2">{{word.birthday}}</label>
                                            <!--<div>-->
                                            <!--<birth-datepicker
                                                :valueIsString="true"
                                                :inline="false"
                                                :high="false"
                                                v-model="dob"
                                            />-->
                                            <!--<date-pick
                                                    v-model="dob"
                                                    :displayFormat="'YYYY-MM-DD'"
                                            ></date-pick>-->
                                            <div class="position-relative col-sm-10">
                                                <datepicker class="form-control" id="dob" name="dob" v-model="dob"
                                                            :place-holder="word.birthday_placeholder"></datepicker>
                                                <small v-if="validationErrors.dob !== null" class="text-danger">
                                                    {{validationErrors.dob}}
                                                </small>
                                            </div>

                                            <!--</div>-->
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="row">
                                            <label class="col-form-label col-sm-2">{{word.hometown}}</label>
                                            <div class="col-sm-10">
                                                <multiselect
                                                        v-model="place"
                                                        id="ajax"
                                                        label="title"
                                                        track-by="title"
                                                        :placeholder="word.type_to_search"
                                                        :options="places"
                                                        :multiple="false"
                                                        :searchable="true"
                                                        :loading="placesSpinner"
                                                        :internal-search="true"
                                                        :max-height="600"
                                                        :show-no-results="true"
                                                        :hide-selected="false"
                                                        @search-change="findPlaces"
                                                >
                                                    <span slot="noResult">{{text.no_elements_found}}</span>
                                                    <span slot="noOptions">{{text.enter_something_for_suggestion}}</span>
                                                </multiselect>
                                                <small v-if="validationErrors.place !== null" class="text-danger">
                                                    {{validationErrors.place}}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="text-center avatar-box">
                                        <img :src="avatarImage">
                                        <button id="avatar-cropper-trigger" :title="text.select_profile_photo">
                                            <i class="fa fa-camera" aria-hidden="true"></i>
                                        </button>
                                        <button id="avatar-remove-button" v-if="avatar" @click="removeAvatar"
                                                title="Remove profile photo">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                        <avatar-cropper
                                                :upload-handler="avatarCropperHandler"
                                                trigger="#avatar-cropper-trigger"
                                                :labels="avatarCropperLabels"
                                                :output-mime="avatarCropperOutputMime"
                                                :output-quality="0.8"
                                                :cropper-options="avatarCropperOptions"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="step == 3" class="tab">
                            <div class="title-step-register2">
                                <h4>
                                    {{
                                    text.some_interesting_details_about_you
                                    }}
                                </h4>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label
                                            for="exampleFormControlTextarea1"
                                    ></label>
                                    <textarea
                                            class="aboutinterestingdetail"
                                            rows="6"
                                            v-model="aboutMe"
                                            :placeholder="text.enter_something_about_me"
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <div v-if="step == 4" class="tab">
                            <div class="title-step-register2">
                                <h4>{{ text.about_your_ideal_partner }}</h4>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label></label>
                                    <textarea
                                            class="aboutinterestingdetail"
                                            rows="6"
                                            v-model="aboutPartner"
                                            :placeholder="text.enter_something_about_partner"
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <div v-if="step == 5" class="tab">
                            <div class="title-step-register2">
                                <h4>{{ text.about_your_interests }}</h4>
                            </div>

                            <div class="form-group">
                                <label for="interests">{{
                                    text.select_your_interests
                                    }}</label>

                                <ul id="interest-list" class="interests-select">
                                    <li v-for="(interest, index) in interests" :id="'interest-'+ interest.id"
                                        @click="updateInterests(interest)">
                                        {{interest.title}}
                                    </li>
                                </ul>

                                <h5 class="h5 mt-5 border-0">{{text.i_will_now_create_your_matchmarry_account}}</h5>

                                <div class="ml-1">
                                    <div class="form-check">
                                        <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="rules"
                                                id="rules-accept"
                                        />
                                        <label
                                                class="form-check-label"
                                                for="rules-accept"
                                        >
                                            I certify that I am over 18 and accept the
                                            <a class="rules-link" target="_blank"
                                               :href="baseUrl+'/terms-and-conditions'">Terms
                                                & Conditions</a>.
                                            Learn about how we process your data in our
                                            <a class="rules-link" target="_blank" :href="baseUrl+'/privacy-policy'">Privacy
                                                Policy</a>,
                                            <a class="rules-link" target="_blank" :href="baseUrl+'/cookie-policy'">Cookie
                                                Policy</a>
                                            and our
                                            <a class="rules-link" target="_blank"
                                               :href="baseUrl+'/rules-on-profiles-visibility'">Rules
                                                on Profiles Visibility</a>.
                                        </label>
                                        <small v-if="validationErrors.rules !== null" class="text-danger">
                                            {{validationErrors.rules}}
                                        </small>
                                    </div>

                                    <div class="form-check">
                                        <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="dataRules"
                                                id="sensitive-data-accept"
                                        />
                                        <label
                                                class="form-check-label"
                                                for="sensitive-data-accept"
                                        >
                                            I consent to the processing of my
                                            <a class="rules-link" target="_blank" :href="baseUrl+'/sensitive-data'">sensitive
                                                data</a>.
                                            by Match to provide me the service.
                                        </label>
                                        <small v-if="validationErrors.dataRules !== null" class="text-danger">
                                            {{validationErrors.dataRules}}
                                        </small>
                                    </div>

                                    <div class="form-check">
                                        <input
                                                type="checkbox"
                                                class="form-check-input"
                                                v-model="emailRules"
                                                id="email-commercial-accept"
                                        />
                                        <label
                                                class="form-check-label"
                                                for="email-commercial-accept"
                                        >
                                            I would like to receive via email commercial offers relating to
                                            products or services provided by partners of MatchMarry.com
                                            International Limited. See our
                                            <a class="rules-link" target="_blank"
                                               :href="baseUrl+'/partnerships'">partners</a>.
                                            You may opt-out at any time in your settings.
                                        </label>
                                        <small v-if="validationErrors.emailRules !== null" class="text-danger">
                                            {{validationErrors.emailRules}}
                                        </small>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </form>

                    <div v-if="dir === 'ltr'">
                        <div style="overflow:auto;">
                            <div class="button-stepforms">
                                <button
                                        class="btn colorBlack"
                                        type="button"
                                        @click="prev()"
                                >
                                    <i class="fas fa-chevron-left"></i>
                                    {{ word.previous }}
                                </button>
                                <button
                                        v-if="step != lastStep && step != 1"
                                        class="btn btn-formstepreg colorBlack"
                                        type="button"
                                        @click="next()"
                                >
                                    {{ word.next }}
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                                <button
                                        v-else-if="
                                            step != lastStep && step == 1
                                        "
                                        class="btn btn-formstepreg colorBlack"
                                        type="button"
                                        @click="loginOrRegister()"
                                >
                                    {{ word.next }}
                                    <i class="fas fa-chevron-right"></i>
                                </button>
                                <button
                                        v-else
                                        class="btn btn-formstepreg colorBlack"
                                        type="button"
                                        @click="submit()"
                                >
                                    {{ word.continue }}
                                </button>
                            </div>
                        </div>
                        <!-- Circles which indicates the steps of the form: -->
                        <div style="text-align:center;margin-top:10px;">
                            <span
                                    class="step"
                                    :class="{ 'active finish': step == 1 }"
                            ></span>
                            <span
                                    class="step"
                                    :class="{ 'active finish': step == 2 }"
                            ></span>
                            <span
                                    class="step"
                                    :class="{ 'active finish': step == 3 }"
                            ></span>
                            <span
                                    class="step"
                                    :class="{ 'active finish': step == 4 }"
                            ></span>
                            <span
                                    v-if="lastStep == 5"
                                    class="step"
                                    :class="{ 'active finish': step == 5 }"
                            ></span>
                        </div>
                    </div>

                    <div v-else>
                        <div style="overflow:auto;">
                            <div class="button-stepforms">
                                <button
                                        class="btn colorBlack"
                                        type="button"
                                        @click="prev()"
                                >
                                    <i class="fas fa-chevron-right"></i>
                                    {{ word.previous }}
                                </button>
                                <button
                                        v-if="step != lastStep && step != 1"
                                        class="btn btn-formstepreg colorBlack"
                                        type="button"
                                        style="float: left !important;"
                                        @click="next()"
                                >
                                    {{ word.next }}
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <button
                                        v-else-if="
                                            step != lastStep && step == 1
                                        "
                                        class="btn btn-formstepreg colorBlack"
                                        type="button"
                                        style="float: left !important;"
                                        @click="loginOrRegister()"
                                >
                                    {{ word.next }}
                                    <i class="fas fa-chevron-left"></i>
                                </button>
                                <button
                                        v-else
                                        class="btn btn-formstepreg colorBlack"
                                        type="button"
                                        style="float: left !important;"
                                        @click="submit()"
                                >
                                    {{ word.continue }}
                                </button>
                            </div>
                        </div>
                        <!-- Circles which indicates the steps of the form: -->
                        <div style="text-align:center;margin-top:10px;">
                            <span
                                    class="step"
                                    :class="{ 'active finish': step == 1 }"
                            ></span>
                            <span
                                    class="step"
                                    :class="{ 'active finish': step == 2 }"
                            ></span>
                            <span
                                    class="step"
                                    :class="{ 'active finish': step == 3 }"
                            ></span>
                            <span
                                    class="step"
                                    :class="{ 'active finish': step == 4 }"
                            ></span>
                            <span
                                    v-if="lastStep == 5"
                                    class="step"
                                    :class="{ 'active finish': step == 5 }"
                            ></span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </vue-model>
</template>

<script>
    import VueModel from "./../../VueModal";
    import "vue-birth-datepicker/dist/vueBirthDatepicker.css";
    import birthDatepicker from "vue-birth-datepicker";
    import Multiselect from "vue-multiselect";
    import AvatarCropper from "vue-avatar-cropper";

    export default {
        components: {
            VueModel,
            birthDatepicker,
            Multiselect,
            AvatarCropper,
        },
        props: {
            auth: {
                type: Boolean,
                default: false
            },
            dir: {
                Type: String,
            },
            baseUrl: {
                type: String,
            },
            isSocialRegister: {
                type: Boolean,
                default: false
            },
            openModal: {
                type: Boolean,
                default: false
            },
            socialData: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                avatarCropperOutputMime: 'image/jpeg',
                avatarCropperLabels: {
                    submit: "Save",
                    cancel: "Cancel"
                },
                avatarCropperOptions: {
                    aspectRatio: 1,
                    autoCropArea: 1,
                    viewMode: 1,
                    movable: false,
                    zoomable: true
                },
                avatar: null,
                avatarFile: null,
                favoriteCountries: [],
                countries: [],
                placesSpinner: false,
                loading: false,
                word: window.word,
                text: window.text,
                name: null,
                email: null,
                password: null,
                iAm: "man",
                lookingFor: "woman",
                startAge: "18",
                endAge: "18",
                aboutMe: null,
                rules: false,
                dataRules: false,
                emailRules: false,
                aboutPartner: null,
                dob: null,
                showModal: false,
                places: [],
                place: null,
                step: 1,
                lastStep: this.auth ? 4 : 5,
                findPlacesTimeOut: null,
                findPlaceDetailTimeOut: null,
                selectedInterests: [],
                interests: [],
                ages: [18, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 80],
                numOfChangeQuery: 0,
                validationErrors: {
                    email: null,
                    password: null,
                    name: null,
                    dob: null,
                    countries: null,
                    place: null,
                    rules: null,
                    dataRules: null,
                    emailRules: null,
                }
            };
        },
        created() {
            this.showModal = this.openModal;

            if (this.isSocialRegister) {
                let socialData = JSON.parse(this.socialData);
                this.step = 2;
                this.name = socialData.name;
                this.email = socialData.email;
                this.password = socialData.password;
            }
            this.getInterests();
            document.addEventListener('open-register', ev => {
                _.forEach(ev.detail, (value, key) => {
                    this.$set(this, key, value)
                })
                this.showModal = true
            })
        },
        computed: {
            avatarImage() {
                if (this.avatar) {
                    return this.avatar;
                }

                if (this.iAm === 'man') {
                    return '/images/resources/avatar_man.jpg';
                }

                return "/images/resources/avatar_woman.jpg";
            }
        },
        methods: {
            updateInterests(interest) {
                let selectedInterest = document.querySelector('#interest-' + interest.id);
                if (selectedInterest.classList.contains('interests-select-active')) {
                    this.selectedInterests = this.selectedInterests.filter(item => item !== interest);
                    selectedInterest.classList.remove('interests-select-active');
                } else {
                    this.selectedInterests.push(interest);
                    selectedInterest.classList.add('interests-select-active');
                }

            },
            removeAvatar() {
                this.avatar = null;
                this.avatarFile = null;
            },
            avatarCropperHandler(cropper) {
                var dataUrl = cropper.getCroppedCanvas().toDataURL(null);

                this.avatar = dataUrl;

                var arr = dataUrl.split(","),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);

                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }

                this.avatarFile = new File([u8arr], 'avatar.jpg', {type: mime});
            },
            favoriteCountryLimitText(count) {
                if (count === this.favoriteCountries.length) {
                    return this.text.all_countries_selected;
                }

                return `${count}` + this.text.country_selected;
            },
            onFavoriteCountrySelect(country) {
                if (country.id === 0) {
                    this.favoriteCountries.map(item => {
                        item.checked = true;
                        return item;
                    })

                    this.favoriteCountries
                        .filter(item => item.id !== 0)
                        .forEach((item, key) => {
                            let index = this.countries.findIndex(i => i.id === item.id);
                            if (index === -1) {
                                this.countries.push(item)
                                this.$emit('handle-select', item.id)
                            }
                        });

                    return;
                }

                let index = this.favoriteCountries.findIndex(item => item.id === country.id);
                this.favoriteCountries[index].checked = true;
            },
            onFavoriteCountryRemove(country) {
                if (country.id === 0) {
                    this.favoriteCountries.map(item => {
                        item.checked = false;
                        return item;
                    })

                    this.countries.splice(0, this.favoriteCountries.length)

                    return;
                }

                let index = this.favoriteCountries.findIndex(item => item.id === country.id);
                this.favoriteCountries[index].checked = false;
            },
            fetchFavoriteCountries() {
                axios.get('/countries')
                    .then(response => {
                        this.favoriteCountries = response.data.data;
                        this.favoriteCountries.unshift({id: 0, name: 'Select all'})
                    })
                    .catch(error => console.log(error));
            },
            next: function () {
                if (this.step === 2) {
                    if (document.getElementsByClassName('vdpComponent')[0].getElementsByTagName('input')[0]) {
                        this.dob = document.getElementsByClassName('vdpComponent')[0].getElementsByTagName('input')[0].value;
                    }
                }

                if (this.step < this.lastStep && this.isValid()) {
                    this.step++;
                }
            },
            prev: function () {
                if (this.isSocialRegister) {
                    if (this.step > 2) {
                        this.step--;
                    }
                    return;
                }

                if (this.step > 1) {
                    this.step--;
                }
            },
            isValid: function () {
                let isValid = true;
                if (this.step == 2 && this.isNullOrUndefined(this.name)) {
                    this.validationErrors.name = this.text.the_name_field_is_required;
                    isValid = false;
                } else {
                    this.validationErrors.name = null;
                }

                if (this.step == 2 && this.name.length < 3) {
                    this.validationErrors.name = this.text.the_name_must_be_at_least_three_characters;
                    isValid = false;
                } else {
                    this.validationErrors.name = null;
                }

                if (this.step == 2 && this.countries.length === 0) {
                    this.validationErrors.countries = this.text.the_countries_field_is_required;
                    isValid = false;
                } else {
                    this.validationErrors.countries = null;
                }

                if (this.step == 2 && this.isNullOrUndefined(this.dob)) {
                    this.validationErrors.dob = this.text.the_birthday_field_is_required;
                    isValid = false;
                } else {
                    this.validationErrors.dob = null;
                }

                if (this.step == 2 && this.place == null) {
                    this.validationErrors.place = this.text.the_hometown_field_is_required;
                    isValid = false;
                } else {
                    this.validationErrors.place = null;
                }

                return isValid;
            },
            isNullOrUndefined: function (input) {
                if (
                    !input ||
                    input.trim() == null ||
                    input.trim() == undefined ||
                    input.trim() == ""
                ) {
                    return true;
                } else {
                    return false;
                }
            },
            action: function () {
                if (this.auth && this.auth == true) {
                    let self = this;
                    self.loading = true;
                    let data = {
                        i_am: self.iAm,
                        looking_for: self.lookingFor,
                        start_age: self.startAge,
                        end_age: self.endAge
                    };
                    axios({
                        method: "post",
                        url: "/en/take-chance",
                        data
                    })
                        .then(res => {
                            self.loading = false;
                            console.log(res);
                            // if (res.data.ok) {
                            //     location.href = "/dashboard";
                            // } else {
                            //     self.$toast.error(res.data.msg);
                            // }
                        })
                        .catch(err => {
                            self.loading = false;
                            console.log(err);
                            // for (const item in err.response.data.errors) {
                            //   self.$toast.error(`${err.response.data.errors[item]}`);
                            // }
                        });
                } else {
                    this.showModal = true;
                }
            },
            submit: function () {
                let self = this;

                self.validationErrors.rules = null;
                self.validationErrors.dataRules = null;
                self.validationErrors.emailRules = null;

                this.loading = true;

                var formData = new FormData();

                let data = {
                    name: this.name,
                    email: this.email,
                    password: this.password,
                    i_am: this.iAm,
                    looking_for: this.lookingFor,
                    about_me: this.aboutMe,
                    about_partner: this.aboutPartner,
                    start_age: this.startAge,
                    end_age: this.endAge,
                    dob: this.dob,
                    rules: this.rules ? 1 : 0,
                    dataRules: this.dataRules ? 1 : 0,
                    emailRules: this.emailRules ? 1 : 0,
                    place: this.place.id,
                    avatar: this.avatarFile,
                };
                for (var key in data) {
                    formData.append(key, data[key] ? data[key] : '');
                }

                let countries = this.countries.filter(item => item.id !== 0).map(item => item.id);
                for (var i = 0; i < countries.length; i++) {
                    formData.append('countries[]', countries[i]);
                }

                let interests = this.selectedInterests.map(item => item.id);
                for (var i = 0; i < interests.length; i++) {
                    formData.append('interests[]', interests[i]);
                }

                if (this.isSocialRegister) {
                    formData.append('is_social_register', true);
                }

                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };

                axios.post("/register", formData, config)
                    .then(res => {
                        this.loading = false;

                        if (res.data.ok) {
                            this.$toast.success(res.data.msg);
                            setTimeout(function () {
                                location.href = "/dashboard";
                            }, 1500);
                        } else {
                            this.$toast.error(res.data.msg);
                        }
                    })
                    .catch(err => {
                        this.loading = false;

                        if (err.response.status === 422) {

                            if (err.response.data.errors['rules']) {
                                self.validationErrors.rules = _.values(err.response.data.errors['rules'])[0];
                            }

                            if (err.response.data.errors['dataRules']) {
                                self.validationErrors.dataRules = _.values(err.response.data.errors['dataRules'])[0];
                            }

                            if (err.response.data.errors['emailRules']) {
                                self.validationErrors.emailRules = _.values(err.response.data.errors['emailRules'])[0];
                            }

                            if (err.response.data.errors['countries'] ||
                                err.response.data.errors['name'] ||
                                err.response.data.errors['dob'] ||
                                err.response.data.errors['email'] ||
                                err.response.data.errors['password']) {
                                for (const item in err.response.data.errors) {
                                    this.$toast.error(`${err.response.data.errors[item]}`);
                                }
                            }
                        }


                    });
            },
            loginOrRegister: function () {
                let self = this;
                self.validationErrors.email = null;
                self.validationErrors.password = null;
                self.loading = true;
                let data = {
                    email: self.email,
                    password: self.password,
                    i_am: self.iAm,
                    looking_for: self.lookingFor,
                    start_age: self.startAge,
                    end_age: self.endAge
                };
                axios({
                    method: "post",
                    url: "/login-or-register",
                    data
                })
                    .then(res => {
                        self.loading = false;
                        if (res.data.ok && res.data.data == "login") {
                            self.$toast.success(res.data.msg);
                            setTimeout(function () {
                                location.href = "/dashboard";
                            }, 1500);
                        } else if (res.data.ok && res.data.data == "register") {
                            self.step++;
                        } else {
                            self.$toast.error(res.data.msg);
                        }
                    })
                    .catch(err => {
                        self.loading = false;
                        if (err.response.status === 422) {
                            if (err.response.data.errors['email']) {
                                self.validationErrors.email = _.values(err.response.data.errors['email'])[0];
                            }

                            if (err.response.data.errors['password']) {
                                self.validationErrors.password = _.values(err.response.data.errors['password'])[0];
                            }
                        }
                    });
            },
            getInterests: function () {
                let self = this;
                self.loading = true;
                axios({
                    method: "get",
                    url: "/interest/all"
                })
                    .then(res => {
                        self.loading = false;
                        if (res.data.ok) {
                            self.interests = res.data.interests;
                        } else {
                            console.log(res.data.msg);
                        }
                    })
                    .catch(() => self.loading = false);
            },
            findPlaces(query) {
                this.numOfChangeQuery++;
                let self = this;
                self.placesSpinner = true;
                if (self.findPlacesTimeOut) {
                    clearTimeout(self.findPlacesTimeOut);
                }
                self.findPlacesTimeOut = setTimeout(function () {
                    axios({
                        method: "get",
                        url: "/places/search/" + query
                    })
                        .then(res => {
                            self.placesSpinner = false;
                            if (res.data.places != undefined) {
                                self.places = res.data.places;
                            }
                        })
                        .catch(() => self.placesSpinner = false);
                }, 1000);
            },
            onPlaceChanged(place) {
                console.log(place)
            }
        },
        mounted() {
            this.fetchFavoriteCountries();
        }
    };
</script>

<style scoped>
    .birthday-picker {
        width: 100%;
        min-height: 3.5em;
    }

    .colorBlack {
        color: black;
    }

    .favorite-country-checkbox-label {
        display: block;
        margin-left: 6px;
    }

    .favorite-country-checkbox {
        position: absolute;
        left: 3px;
    }

    .register-step-two {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }

    .regForm .gender input[type="radio"] {
        display: none;
    }

    .regForm .gender input[type="radio"]:checked + .box span {
        transform: translateY(50px);
    }

    .regForm .gender .sex-type {
        align-items: center;
        flex-direction: row;
    }

    .regForm .gender .sex-type i {
        margin-right: 5px;
    }

    .regForm .gender .box {
        width: 100px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .regForm .gender .box span {
        transform: translate(0, 50px);
        color: #FF1494;
        font-size: 14px;
    }

    .regForm .gender input[type="radio"]:checked + .male {
        border: 1px solid #d40c79;
        background-color: #FF1494;
    }

    .regForm .gender input[type="radio"]:checked + .male span {
        color: #fff;
    }

    .regForm .gender input[type="radio"]:checked + .female span {
        color: #fff;
    }

    .regForm .gender input[type="radio"]:checked + .female {
        border: 1px solid #d40c79;
        background-color: #FF1494;
    }

    .regForm .gender .box {
        background-color: transparent;
        border-radius: 4px;
        border: 1px solid #FF1494;
    }

    .regForm .gender .male {
        background-color: transparent;
    }

    .avatar-box > img {

        border-radius: 4px;
        border: 1px solid #cccccc;
        background-color: #f0f0f0;
    }

    .avatar-box #avatar-cropper-trigger {
        margin-top: 10px;
        border-radius: 4px;
        background-color: #07b6e5;
        color: #ffffff;
        padding: 8px 20px;
    }

    .avatar-box #avatar-remove-button {
        margin-top: 10px;
        border-radius: 4px;
        background-color: #e22f2f;
        color: #ffffff;
        padding: 8px 20px;
    }
</style>
